const regexPatterns = {
  e_mail: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  password: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{8,}$/, // Minimum 8 karaktera, bar jedno slovo, broj i specijalni znak
  lat: /^-?([1-8]?\d(\.\d+)?|90(\.0+)?)$/, // Latitude od -90 do 90
  lng: /^-?(1[0-7]\d(\.\d+)?|180(\.0+)?|[1-9]?\d(\.\d+)?)$/, // Longitude od -180 do 180
  number: /^\d+$/, // samo cifre
  jmbg: /^\d{13}$/, // tačno 13 cifara
};

export function validateString(input, type) {
  const pattern = regexPatterns[type];
  if (!pattern) {
    throw new Error(`Nevalidan tip regexa: ${type}`);
  }
  return !pattern.test(input);
}
